<template>
  <b-form-select
    :options="options"
    :value="value"
    @input="updateValue"
  />
</template>

<script>
export default {
  name: 'MonthsInYear',

  props: {
    data: {
      type: Object
    },

    value: {
      type: Number
    }
  },

  computed: {
    options () {
      return Object.keys(this.data).map(key => ({
        value: Number(key),
        text: this.data[key]
      }))
    }
  },

  methods: {
    updateValue (value) {
      this.$emit('input', value)
    }
  }
}
</script>
